/* eslint-disable no-new */
import TermDisplay from 'modules/term-display'

export default class LayoutTerms {
  constructor(element) {
    this.element = element
    new TermDisplay(this.element)
  }
}
